/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@one-thd/sui-atomic-components';

export const AddToListProductInfo = ({
  identifiers,
  primaryImage
}) => {
  if ((!identifiers && !primaryImage)) {
    return null;
  }

  return (
    <div className="sui-flex sui-pb-6 sui-flex-row sui-border-primary sui-border-b-2 sui-border-solid">
      <img
        src={primaryImage?.url?.replace('<SIZE>', '80')}
        alt={identifiers?.productLabel}
        className="sui-aspect-square sui-max-w-[20%] sm:sui-max-w-[30%]"
        width="80px"
        height="80px"
      />
      <div className="sui-pl-6">
        <Typography weight="bold">{identifiers?.brandName}</Typography>
        <Typography>{identifiers?.productLabel}</Typography>
      </div>
    </div>
  );
};

AddToListProductInfo.displayName = 'AddToListProductInfo';

AddToListProductInfo.propTypes = {
  identifiers: PropTypes.shape({
    brandName: PropTypes.string,
    productLabel: PropTypes.string
  }),
  primaryImage: PropTypes.shape({
    url: PropTypes.string
  })
};

AddToListProductInfo.defaultProps = {
  identifiers: {},
  primaryImage: {}
};